
type TimeStripProps = {
  topPosition: number,
  dateItem: Date,
}

const TimeStrip = (props: TimeStripProps) => {
  return (
    <div
      className="time-strip"
      key={props.dateItem.toISOString()}
      style={{ top: props.topPosition }}>
      <p>{props.dateItem.toDateString()}</p>
    </div>
  );
}

export default TimeStrip;
